import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "calendarIcon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "lineOne" }, "|", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "lineTwo" }, "|", -1)
const _hoisted_4 = { class: "month" }
const _hoisted_5 = { class: "numb" }
const _hoisted_6 = { class: "day" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.date !== null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$moment(_ctx.date).format("MMM")), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$moment(_ctx.date).format("DD")), 1),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$moment(_ctx.date).format("ddd")), 1)
      ]))
    : _createCommentVNode("", true)
}